module.exports = __webpack_public_path__ + "97c798319f7efc5a05f1bf4631263c2c.pdf";